import React, { useState } from "react";
import { makeStyles, Typography } from "@material-ui/core";
import { Col, Row } from "react-bootstrap";
import { CurrencyFormat } from "../../../Helpers/Formatters";
import { CurrencyFormatFunc } from "../../../Helpers/Formatters/CurrencyFormat";
import IconHolder from "../../../Helpers/IconHolder";
import ScheduleCalender from '../../../../icons/schedulecalender.svg';
import { ProductDetailsDialog } from "./ProductDetailModel";
import PropTypes from 'prop-types';
import ProductDetails from "../../FullUW/Helpers/ProductDetails";
import './AppointmentProductDetail.scss';

const useStyles = makeStyles(theme => ({
  ratingText: {
    color: theme.palette.primary.main,
  }
}));

export default function AppointmentProductDetail(props) {
  const { quote } = props;
  const [isProductDetailsDialogOpen, setIsProductDetailsDialogOpen] = useState(false);
  const classes = useStyles();

  return (
    <div>
      <Row className="coverage-detail">
        {!quote || quote.isSelectOrTalk === "contactSpecialist" ?
          <Col className="carrier-container text-center d-flex justify-content-center align-items-center pr-0 pt-2">
            <div className="mt-1">
              <IconHolder icon={ScheduleCalender} viewBox="0 0 25 25"/>
            </div>
            <Typography variant="body1" component="div">
              <h6 className='mt-2'><b>TERM LIFE INSURANCE</b></h6>
            </Typography>
          </Col>
          :
          <Col className="carrier-container carrier-logo-container text-center pr-0 pt-3">
            <img src={quote.carrierLogoUrl} alt="Carrier Logo"
                 className={(quote.carrierName && quote.carrierName.toLowerCase() === "lga") ? "lg" : ""}/>
            <p className={classes.ratingText}>{quote.selectedQuote && quote.selectedQuote.rating} Rating</p>
          </Col>
        }
        <Col className="carrier-container d-flex justify-content-center align-items-start pl-0">
          <div className="coverage mt-3">
            <h6><b>Coverage Amount</b></h6>
            <p className="coverage-amount"><CurrencyFormat number={quote.coverageAmount} whole /></p>
            <p className="quote-amount">{quote.premium ? `${CurrencyFormatFunc(quote.premium)}/mo` : ''}
              <span>{quote.termLength} Year Term</span></p>
            {quote.isSelectOrTalk === "quoteSelect" &&
              <button type="button" className={`${classes.ratingText} product-detail-btn`}
                      onClick={() => setIsProductDetailsDialogOpen(true)}>Approval Process</button>}
          </div>
        </Col>
      </Row>
      {quote.isSelectOrTalk === "quoteSelect" && props.quote.selectedQuote &&
        <ProductDetailsDialog
          isOpen={isProductDetailsDialogOpen}
          productDetails={
            <ProductDetails
              carrierName={props.quote.selectedQuote.carrierName}
              productDescription={props.quote.selectedQuote.productDescription}
              hasPermConversion={props.quote.selectedQuote.hasConvertibility}
              productInformation={props.quote.selectedQuote.productInformation}
            />
          }
          quoteCardProps={props.quote.selectedQuote}
          hideSelect
          onClose={() => setIsProductDetailsDialogOpen(false)}
        />
      }
    </div>
  );
}

AppointmentProductDetail.propTypes = {
  quote:PropTypes.object
};



// WEBPACK FOOTER //
// ./src/components/Quoters/CustomizeTerm/QuoterComponents/AppointmentProductDetail.js